export default __webpack_public_path__ + "static/media/imgBoatBgrHome.9c970d7d.png";